module.exports = __webpack_public_path__ + "img/content1.826b0d43.png";